import { createSelector } from 'reselect';
import dayjs from '../../../../utils/dayjs';

/** Backend sometimes returns sentinel empties (e.g. 01/01/1901) instead of null. */
function normalizeDate(value) {
  if (value == null || value === '') return null;
  const parsed = dayjs(value);
  if (!parsed.isValid()) return null;
  // Treat classic SQL / .NET-style placeholder dates as missing.
  if (parsed.year() <= 1901) return null;
  return value;
}

/** Normalize UserTransactionDto (and tolerate older brokerage-shaped rows). */
const normalizeTransaction = (record = {}) => ({
  ...record,
  date: normalizeDate(record.date || record.createdDate),
  expiryDate: normalizeDate(record.expiryDate),
  amount: record.amount != null && record.amount !== '' ? Number(record.amount) : null,
  // Display type exactly as BE sends it (e.g. "Purchase (Admin Assigned)").
  type: record.type != null && String(record.type).trim() !== '' ? String(record.type).trim() : null,
  description: record.description || null,
  initiator: record.initiator || record.createdBy || null,
  purchasedByUserId: record.purchasedByUserId || null,
  paymentId: record.paymentId != null ? record.paymentId : record.payment?.paymentId ?? null,
  receiptNumber: record.payment?.receiptNumber || record.receiptNumber || null,
  fromBrokerageName: record.fromBrokerageName || record.fromBrokerage || null,
  toBrokerageName: record.toBrokerageName || record.toBrokerage || null,
});

export const transactionsSelector = createSelector(
  (state) => state.transactionReducer.transactions,
  (transactions) => (Array.isArray(transactions) ? transactions.map(normalizeTransaction) : []),
);

export const loadingTransactionsSelector = (state) => state.transactionReducer.loadingTransactions;
